import { DISK_TYPES, FILE_META } from "constants/system";
import { ICONS } from "constants/icons";
import { DEFAULT_README_TEXT } from "constants/desktop";
import { type DesktopFile, FILE_TYPE } from "types/desktop";

const DesktopInitialContent: DesktopFile[] = [
    {
        name: FILE_META.DEFAULT_README_FILE.name,
        icon: ICONS.TEXT_FILE,
        type: FILE_TYPE.TEXT,
        innerContent: DEFAULT_README_TEXT,
        id: FILE_META.DEFAULT_README_FILE.id,
        isSelected: false,
        parentId: FILE_META.DESKTOP.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
    {
        name: FILE_META.DEFAULT_EMPTY_FOLDER.name,
        icon: ICONS.FOLDER,
        type: FILE_TYPE.FOLDER,
        innerContent: [],
        id: FILE_META.DEFAULT_EMPTY_FOLDER.id,
        isSelected: false,
        parentId: FILE_META.DESKTOP.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
    {
        name: FILE_META.GITHUB.name,
        icon: ICONS.GITHUB,
        isSelected: false,
        type: FILE_TYPE.LINK,
        id: FILE_META.GITHUB.id,
        link: "https://github.com/YarovyiDm/windows",
        parentId: FILE_META.DESKTOP.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
    {
        name: FILE_META.LINKEDIN.name,
        icon: ICONS.LINKEDIN,
        isSelected: false,
        type: FILE_TYPE.LINK,
        id: FILE_META.LINKEDIN.id,
        link: "https://www.linkedin.com/in/dmytro-yarovyi-31072b152/",
        parentId: FILE_META.DESKTOP.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
    {
        name: FILE_META.BIN.name,
        icon: ICONS.BIN,
        type: FILE_TYPE.BIN,
        innerContent: [],
        id: FILE_META.BIN.id,
        isSelected: false,
        parentId: FILE_META.DESKTOP.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
];

const UserInitialContent: DesktopFile[] = [
    {
        name: FILE_META.DESKTOP.name,
        icon: ICONS.FOLDER,
        type: FILE_TYPE.FOLDER,
        innerContent: DesktopInitialContent,
        id: FILE_META.DESKTOP.id,
        isSelected: false,
        parentId: FILE_META.SYSTEM_USER.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: false,
    },
];

const UsersInitialContent: DesktopFile[] = [
    {
        name: FILE_META.SYSTEM_USER.name,
        icon: ICONS.FOLDER,
        type: FILE_TYPE.FOLDER,
        innerContent: UserInitialContent,
        id: FILE_META.SYSTEM_USER.id,
        isSelected: false,
        parentId: FILE_META.USERS.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: false,
    },
];

const DiskCInitialContent: DesktopFile[] = [
    {
        name: FILE_META.USERS.name,
        icon: ICONS.FOLDER,
        type: FILE_TYPE.FOLDER,
        innerContent: UsersInitialContent,
        id: FILE_META.USERS.id,
        isSelected: false,
        parentId: FILE_META.DISK_C.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: false,
    },
    {
        name: FILE_META.PROGRAM_FILES.name,
        icon: ICONS.FOLDER,
        type: FILE_TYPE.FOLDER,
        innerContent: [],
        id: FILE_META.PROGRAM_FILES.id,
        isSelected: false,
        parentId: FILE_META.DISK_C.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
    {
        name: FILE_META.MICROSOFT.name,
        icon: ICONS.FOLDER,
        type: FILE_TYPE.FOLDER,
        innerContent: [],
        id: FILE_META.MICROSOFT.id,
        isSelected: false,
        parentId: FILE_META.DISK_C.id,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        draggable: true,
    },
];

export const RootInitialContent: DesktopFile[] = [
    {
        name: FILE_META.DISK_C.name,
        icon: ICONS.DISK,
        type: FILE_TYPE.FOLDER,
        innerContent: DiskCInitialContent,
        id: FILE_META.DISK_C.id,
        isSelected: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.C,
        systemFile: true,
        parentId: FILE_META.ROOT.id,
        draggable: false,
    },
    {
        name: FILE_META.DISK_D.name,
        icon: ICONS.DISK,
        type: FILE_TYPE.FOLDER,
        innerContent: [],
        id: FILE_META.DISK_D.id,
        isSelected: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        diskId: DISK_TYPES.D,
        systemFile: true,
        parentId: FILE_META.ROOT.id,
        draggable: false,
    },
];